import React from 'react';
import Surface from 'mini-campaign-surface/lib/components/Surface';
import { getMailSurfaceCampaignCustomRules } from '../utils/getMailSurfaceCampaignCustomRules';
import { getMailSurfaceIrisRealtimeSignals } from '../utils/getMailSurfaceIrisRealtimeSignals';
import { PlacementId } from 'mini-campaign-bootstrap/lib/schema/PlacementId';

export const MiniMailCampaignSurface = (): JSX.Element => (
    <Surface
        placementId={PlacementId.MiniMailSurface}
        getRealtimeSignals={getMailSurfaceIrisRealtimeSignals}
        customCampaignRules={getMailSurfaceCampaignCustomRules()}
    />
);
